import SpaceBetween from "@cloudscape-design/components/space-between";
import {
  Box,
  Table,
  Button,
  TextFilter,
  Pagination,
  CollectionPreferences,
  ColumnLayout,
  Container,
  Header,
  Link,
  StatusIndicator,
} from "@cloudscape-design/components";

import Grid from "@cloudscape-design/components/grid";

import { useParams } from "react-router-dom";
import SummaryDetail from "./SummaryDetail";
import DetailOverview from "./DetailOverview";
import DetailMap from "./DetailMap";
import TabsDetail from "./TabsDetail";
import TabsDetailVehicle from "./TabsDetailVehicle";


// this is for container detail page calling all of detail page component
interface Item {
    name: string;
    Ltime: string;
    Press1: string;
    Press2: string;
    Press3: string;
    Press4: string;
    Press5: string;
    Press6: string;
    Temp1: string;
    Temp2: string;
    Temp3: string;
    Temp4: string;
    Temp5: string;
    Temp6: string;
    Batt1: string;
    Batt2: string;
    Batt3: string;
    Batt4: string;
    Batt5: string;
    Batt6: string;
    CTime: string;
    Site: string;
    Prov: string;
    DateRegis: string;
    TimeZone: string;
    Kontak: string;
    NoKontak: string;
    Email: string;
    Status: string;
  }


interface ItemDetailPageProps {
    data: Item[];
  }

const DetailDashboard: React.FC = () => {
    
  return (
    <SpaceBetween size="l">
      <TabsDetailVehicle />
      {/* <Grid
        gridDefinition={[
          { colspan: { default: 12, xxs: 3 } },
          { colspan: { default: 12, xxs: 9 } },
          { colspan: 12},
          { colspan: 12 },
          { colspan: 12 },
          
        ]}
      >
       
         <DetailOverview />
         <SummaryDetail/>
         
         <DetailMap />
         <TabsDetail />
       
          
      </Grid> */}
    
    </SpaceBetween>
  );
}

export default DetailDashboard;
